import { UsersThree, ThumbsUp, ThumbsDown, PhoneX, Hourglass, SealCheck } from '@phosphor-icons/react';

const CARDS = [
  { key: 'total', label: 'Total Lineup', bg: '#93C5FD', icon: UsersThree, testId: 'stat-total' },
  { key: 'going', label: 'Going / Selected', bg: '#4ADE80', icon: ThumbsUp, testId: 'stat-going' },
  { key: 'not_going', label: 'Not Going', bg: '#F87171', icon: ThumbsDown, testId: 'stat-not-going' },
  { key: 'no_response', label: 'No Response', bg: '#FDE047', icon: PhoneX, testId: 'stat-no-response' },
  { key: 'pending', label: 'Pending / Will Inform', bg: '#F9A8D4', icon: Hourglass, testId: 'stat-pending' },
  { key: 'selected', label: 'Selected', bg: '#A3E635', icon: SealCheck, testId: 'stat-selected' },
];

export const StatsBar = ({ summary }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6" data-testid="stats-bar">
    {CARDS.map(({ key, label, bg, icon: Icon, testId }, i) => (
      <div
        key={key}
        data-testid={testId}
        className="border-2 border-black rounded-md p-3 shadow-[4px_4px_0px_0px_rgba(10,10,10,0.6)] animate-in fade-in slide-in-from-bottom-2"
        style={{ backgroundColor: bg, animationDelay: `${i * 60}ms` }}
      >
        <div className="flex items-center justify-between">
          <span className="text-3xl font-black text-black leading-none">{summary?.[key] ?? 0}</span>
          <Icon size={26} weight="duotone" className="text-black/70" />
        </div>
        <div className="text-[10px] font-bold uppercase tracking-wider text-black mt-2">{label}</div>
      </div>
    ))}
  </div>
);
